export default function getParent (elem, selector) {

	if (!(elem instanceof HTMLElement)) {
		return null;
	}

	let parent = elem.parentElement;

	if (!selector) {
		return parent;
	}

	while (parent) {
		if (parent.matches(selector)) {
			return parent;
		}
		parent = parent.parentElement;
	}

	return null;

};
